module.exports = ":host .title{margin-bottom:2rem}\n"